<template>
  <div class="home-page">
    
    <AppBanner />
    <testMeow style="display:none"/>
    <div v-if= Fasle style="display: none;">


    </div>
    <AppCards />

    <AppMap />
    <LatestNews />

    <PromotionsList />

    <NewParkingLots />

    <div class="slogan">
      <h2>為了未來的停車場域解決方案而前進</h2>
    </div>
    <ContactFooter />
  </div>
</template>

<script>
import testMeow from '@/components/home/testMeow.vue'
import AppBanner from '@/components/home/AppBanner.vue'
import AppCards from '@/components/home/AppCards.vue'
import AppMap from '@/components/home/ParkingMap.vue'
import LatestNews from '@/components/home/LatestNews.vue'
import PromotionsList from '@/components/home/Promotions.vue'
import NewParkingLots from '@/components/home/NewParkingLots.vue'
import ContactFooter from '@/components/ContactFooter.vue'

export default {
  name: 'HomePage',
  components: {
    testMeow,
    AppBanner,
    AppCards,
    AppMap,
    LatestNews,
    PromotionsList,
    NewParkingLots,
    ContactFooter,

  }
}
</script>

<style scoped>
.home-page {
  /* 使用百分比或vw单位来适应不同屏幕 */
  width: 100%;
  /* max-width: 1920px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--background-gray);
  /* padding: 0 1rem; */
  padding: 0px 0px;
  margin: 0 0;
}

.slogan {
  background-color: var(--green03);
  /* padding: 20px 0; */
  width:100%;
  height:320px;
  /* make the content center both horizontally and vertically */
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  margin-top: 96px;
  padding: 0;

}

/* 标题样式 */
.slogan h2 {
  color: white;
  font-size: 64px;
  /* 调整字体大小 */
  text-align: center;
  font-weight: 700;
  /* background-color: var(--primary-green); */
  padding: 30px 0;
  width: 100%;
  margin: 0;
}




@media (max-width: 560px) {

  .slogan h2 {
    font-size: 32px;
  }

  .slogan {
    margin-top: 77px;
  }

}




</style>
